import React from 'react'
import {useTranslation} from 'react-i18next'


export const translationHook = (Component) => {
    return (props) => {
        const { t, i18n } = useTranslation('common')
        return <Component {...props} t={t} i18n={i18n}  />
    }
}